module.exports = __webpack_public_path__ + "static/media/YF14_2.e160af0c.jpg";